// extracted by mini-css-extract-plugin
export default {"zoomModal":"AZ-z"};